import { PricingHero } from "@/components/pricing/PricingHero";
import { FreeSmallBusinessPlan } from "@/components/pricing/FreeSmallBusinessPlan";
import { HubPricingSection } from "@/components/pricing/HubPricingSection";
import { PricingToggle } from "@/components/pricing/PricingToggle";
import { PricingFAQ } from "@/components/pricing/PricingFAQ";
import { PricingCTA } from "@/components/pricing/PricingCTA";
import { useState } from "react";

const Pricing = () => {
  const [billingPeriod, setBillingPeriod] = useState<"monthly" | "annual">("annual");

  return (
    <div className="min-h-screen bg-background">
      <PricingHero />
      <FreeSmallBusinessPlan />
      
      {/* Billing Toggle */}
      <div className="py-8 px-4 bg-muted/30">
        <div className="container mx-auto max-w-7xl">
          <PricingToggle 
            billingPeriod={billingPeriod}
            onBillingChange={setBillingPeriod}
          />
        </div>
      </div>

      <HubPricingSection billingPeriod={billingPeriod} />
      <PricingFAQ />
      <PricingCTA />
    </div>
  );
};

export default Pricing;
